<template>
    <div class="mobile">
        <locais/>
    </div>
    <div class="desktop">
        <graficos-mapa/>
    </div>
</template>

<script>
export default {}
</script>